import { useParams } from 'react-router-dom';
import { usePageTitle, useVerifyPin } from '../../logic';
import { UnauthedComponent } from "../shared/UnauthedComponent";
import { GenericPinErrorDialog } from '../shared/dialogs/errorDialogs/pin/GenericPinErrorDialog';
import { CsError } from '../../logic/CsError';

const ERROR_MESSAGE = "We had an issue processing your request. Please try again or contact us for assistance."

export function UnauthedTaskPage({ drawerHeight }: {
  drawerHeight: number
}) {
  usePageTitle('Welcome!')

  const { closingId: orderKey, userOrderKey, id: notificationId } = useParams() as { closingId: string; userOrderKey: string; id: string }

  const {
    isLoading: loading, error, mutate: mutateVerifyPin
  } = useVerifyPin(orderKey, notificationId, userOrderKey, {
    useErrorBoundary: false
  })

  function onSubmit(pin: string) {
    mutateVerifyPin({ Pin: pin })
  }

  return <>
    <UnauthedComponent drawerHeight={drawerHeight} onSubmit={onSubmit} loading={loading} pinIsCorrect={false} text={'Open your task'} text2={'Unlock your task'}/>

    {/* ERROR DIALOG*/}
    {error && (
      // Using empty try again func to just close the dialog. In this case, trying
      // the same req again doesn't make sense, nor does reloading the page so it's
      // just a close button so they can double check their pin etc.
      <GenericPinErrorDialog error = { new CsError(ERROR_MESSAGE) }/>
    )}

  </>
}
